import { Chart } from 'chart.js';

Chart.defaults.font.size = 14;
Chart.defaults.font.family = 'Lato';
Chart.defaults.layout.padding = { top: 16, left: 0 };
Chart.defaults.plugins.legend.maxWidth = 190;

// percentage of width each bar should take up of its category
Chart.defaults.datasets.bar.categoryPercentage = 0.95;
Chart.defaults.datasets.bar.barPercentage = 0.9;
// Chart.defaults.datasets.bar.barThickness = 'flex';

export { HorizontalBarChart } from './horizontalBarChart';
export type { BarChartOptions } from './horizontalBarChart';

export { StackedBarChart } from './stackedBarChart';
export type { StackedBarChartOptions, StackedData, StackedDataSet, StackedScaleOptions } from './stackedBarChart';

export { LineChart } from './lineChart';
export type { LineChartOptions, LineData } from './lineChart';

export { SlopeChart } from './slopeChart';
export type { SlopeData, SlopeChartOptions } from './slopeChart';

export type { Data, DataSet, ScaleOptions } from './types';

export { KpiTrendChart } from './kpiTrend';
export type { TrendsInfo, TrendRow, TrendValue } from './kpiTrend';

export { ChartColors } from './constants';
